import {ChoiceField, ModelControler, ModelErrorMap} from "../lib/ModelController";
import firebase from "firebase/compat";
import {BaseModel} from "./Core";
import fb from "../lib/firebase";


export interface ProprietarioObject extends BaseModel {
  criado_por: firebase.firestore.DocumentReference;
  atualizado_por: firebase.firestore.DocumentReference;

  nome: string;
  pessoa_tipo: 'pf' | 'pj';
  telefone: string;
  _telefone: string;
  cidade: string;
  estado: string;

  // state
  _users: string[];
  _orfao: boolean;
  _num_fazendas: number
  _atribuido_nome: boolean;
  _atribuido_telefone: boolean;
}


export const pessoaTipoChoices: ChoiceField = {
  _choices: {
    pf: 'Pessoa física',
    pj: 'Pessoa jurídica',
  },
  getChoices() {
    return Object.keys(this._choices).map(k => ({value: k, label: this._choices[k]}));
  },
  getValues() {
    return Object.keys(this._choices);
  },
  getLabel(value: string) {
    return this._choices[value];
  },
  getValue(label: string) {
    return Object.keys(this._choices).find(k => this._choices[k] === label);
  }
};

export class ProprietarioController extends ModelControler<ProprietarioObject> {
  onClean() {
    const instance = this.getInstance();
    const {pessoa_tipo, telefone} = instance;
    const errors = new ModelErrorMap()

    if (pessoa_tipo) {
      if (pessoaTipoChoices.getValues().indexOf(pessoa_tipo) === -1) {
        errors.addError('pessoa_tipo', 'Tipo de pessoa inválido');
      }
    }

    this.set('_telefone', telefone ?
      telefone.replace(/\D/g, '') : '');

    return errors;
  }

  async preSave() {
    // preparar campos adicionais para salvar
    const instance = this.getInstance();
    const userRef = this.loadUser();

    if (this.isNew) {
      instance.criado_por = userRef;
      instance._orfao = true;
      instance._num_fazendas = 0;
      instance._users = [userRef.id];
    }
    instance._atribuido_nome = false;
    instance._atribuido_telefone = false;
    instance.atualizado_por = userRef;

    return instance;
  }

  async onSave(values: ProprietarioObject) {
    if (this.isNew) {
      return fb.document.create('proprietarios', values);
    } else {
      return fb.document.update(
        'proprietarios',
        this.get('id'),
        values,
      );
    }
  }
}